import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[800px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/77344bda5046c852c8126df05971afa9.jpg"
          alt="Travel Destination"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/40 via-navy-900/30 to-navy-900/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            style={{ textShadow: '0 2px 20px rgba(0,0,0,0.3)' }}
          >
            Explore the World<br />the Sweet Way
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-2xl text-white/90 font-light mb-12 leading-relaxed"
            style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}
          >
            Unforgettable journeys crafted with care, adventure, and a touch of sweetness
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-wrap items-center gap-4"
          >
            <Link
              to="/tours"
              className="px-10 py-4 bg-gradient-to-r from-primary-600 to-accent-pink text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              View Our Tours
            </Link>
            <a
              href="#contact"
              className="px-10 py-4 border-2 border-white text-white rounded-full font-semibold text-lg hover:bg-white hover:text-navy-900 transition-all cursor-pointer whitespace-nowrap"
            >
              Plan My Trip
            </a>
          </motion.div>
        </div>
      </div>

      {/* Trust Badges */}
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
        className="absolute bottom-12 right-12 hidden lg:flex flex-col gap-4"
      >
        <div className="bg-white/10 backdrop-blur-md rounded-2xl px-6 py-4 border border-white/20">
          <p className="text-3xl font-bold text-white">500+</p>
          <p className="text-sm text-white/80">Happy Travelers</p>
        </div>
        <div className="bg-white/10 backdrop-blur-md rounded-2xl px-6 py-4 border border-white/20">
          <p className="text-3xl font-bold text-white flex items-center gap-1">
            4.9<i className="ri-star-fill text-accent-yellow text-2xl"></i>
          </p>
          <p className="text-sm text-white/80">Average Rating</p>
        </div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-white rounded-full"
          ></motion.div>
        </div>
      </motion.div>
    </section>
  );
}